<script lang="ts" setup>
import { EmbeddedVideo } from '@forgd/ui-kit/blocks/embedded-video'
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@forgd/ui-kit/dialog'

const open = defineModel<boolean>('open', { default: false })

const embedUrl = 'https://www.youtube.com/embed/2Y0BagFAbAY?rel=0&modestbranding=1&showinfo=0&autoplay=1'
</script>

<template>
  <Dialog :open="open" @update:open="(value) => !value && (open = false)">
    <DialogContent hide-close class="h-[33.75vw] w-[60vw] max-w-none overflow-hidden rounded-2xl border-0 bg-black p-0! sm:rounded-2xl">
      <DialogTitle class="sr-only">
        What is the UTR?
      </DialogTitle>
      <DialogDescription class="sr-only">
        Watch the Forgd Universal Token Rating overview video.
      </DialogDescription>
      <EmbeddedVideo
        v-if="open"
        :src="embedUrl"
        title="What is the UTR?"
        aspect-ratio="16/9"
        class="w-full rounded-none bg-black"
      />
    </DialogContent>
  </Dialog>
</template>
